// Auth hooks. The "session" is just the current operator.
// Source of truth: the /api/auth/me endpoint. The query is enabled only
// when we know the setup is done (so we don't 401 on the very first run).

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authApi } from "./api";

export const authKeys = {
  setupStatus: ["auth", "setupStatus"] as const,
  operators: ["auth", "operators"] as const,
  me: ["auth", "me"] as const,
};

export function useSetupStatus() {
  return useQuery({
    queryKey: authKeys.setupStatus,
    queryFn: authApi.setupStatus,
    staleTime: Infinity,
  });
}

export function useOperators(enabled: boolean) {
  return useQuery({
    queryKey: authKeys.operators,
    queryFn: authApi.operators,
    enabled,
  });
}

export function useMe(enabled: boolean) {
  return useQuery({
    queryKey: authKeys.me,
    queryFn: authApi.me,
    enabled,
    retry: false,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.login,
    onSuccess: (op) => {
      qc.setQueryData(authKeys.me, op);
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.logout,
    onSuccess: () => {
      qc.setQueryData(authKeys.me, null);
      qc.removeQueries({ queryKey: authKeys.me });
    },
  });
}
